module.exports = __webpack_public_path__ + "static/media/player_close.fd2c862f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/album/player_close.png
// module id = 324
// module chunks = 150